import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";

import { DasboardContext } from "../../context/dashboard-context";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import "../VitalDetail/style.css";

const API_BASE = "https://app.vivasmartcare.com/api";

const HobacareVitalDetail = () => {
  const { sidebarOpen, bedData } = useContext(DasboardContext);
  const { id } = useParams();

  const [thisDevice, setThisDevice] = useState({});
  const [loadingToken, setLoadingToken] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!bedData || bedData.length === 0) return;
    const found = bedData.find((item) => item.deviceID === id);
    setThisDevice(found || {});
  }, [bedData, id]);

  const openSleepReport = async () => {
    setLoadingToken(true);
    setError("");
    try {
      const r = await fetch(`${API_BASE}/hoba-token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const j = await r.json();
      if (!j.success || !j.access_token) {
        throw new Error(j.message || "Token alınamadı");
      }
      const params = new URLSearchParams({
        uid: id,
        token: j.access_token,
        freshToken: j.refresh_token || "",
        defaultExpand: "sleepReport",
        lang: "en_US",
      });
      window.open(
        `https://qinglanst.com/single/rommDetails?${params.toString()}`,
        "_blank",
        "noopener,noreferrer"
      );
    } catch (e) {
      console.error("Uyku raporu açma hatası:", e);
      setError(e.message || "Bir hata oluştu");
    } finally {
      setLoadingToken(false);
    }
  };

  return (
    <>
      <Breadcrumb />
      <div
        className={`device-wrapper component-wrapper ${
          sidebarOpen ? "" : "close"
        }`}
      >
        {(thisDevice.roomName || thisDevice.suiteName) && (
          <div className="vital-info">
            {thisDevice.roomName && (
              <p>
                Oda Adı: <strong>{thisDevice.roomName}</strong>
              </p>
            )}
            {thisDevice.suiteName && (
              <>
                <p>|</p>
                <p>
                  Süit Adı: <strong>{thisDevice.suiteName}</strong>
                </p>
              </>
            )}
          </div>
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "60px 20px",
            gap: "16px",
            maxWidth: "640px",
            margin: "0 auto",
          }}
        >
          <Button
            variant="primary"
            size="lg"
            onClick={openSleepReport}
            disabled={loadingToken}
          >
            {loadingToken ? "Açılıyor..." : "Uyku Raporu Görüntüle"}
          </Button>

          <p
            style={{
              color: "#666",
              fontSize: "0.9rem",
              textAlign: "center",
              margin: 0,
            }}
          >
            Gittiğiniz sayfada tarih seçimi yaparak son 30 güne bakabilirsiniz.
          </p>

          <div
            style={{
              background: "#fff8e1",
              border: "1px solid #ffe082",
              borderRadius: "8px",
              padding: "14px 18px",
              color: "#5d4037",
              fontSize: "0.9rem",
              lineHeight: 1.55,
              textAlign: "left",
              marginTop: "8px",
            }}
          >
            <strong>Önemli — Tarih Seçimi Hakkında</strong>
            <br />
            Uyku raporu akşam 20.00 ve ertesi gün sabah 08.00 arasındaki
            veriler ile düzenlenmektedir. Tarih seçimi yaparken ertesi gün
            sabahın tarihi seçilmelidir, örneğin 18 Mayıs gecesinin uyku
            raporu için 19 Mayıs tarihi seçmelisiniz.
          </div>

          {error && (
            <div
              style={{
                background: "#fdecea",
                border: "1px solid #f5c6cb",
                color: "#a94442",
                borderRadius: "8px",
                padding: "10px 14px",
                fontSize: "0.9rem",
              }}
            >
              {error}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default HobacareVitalDetail;
